/**
 * Defines a custom error class that is returned by invoking cancellation api
 */
class CancelRequestError {
  name: string;

  message: string;

  retryable: boolean;

  failedItems?: any[];

  stack: string | undefined;

  constructor(message: string, retryable: boolean, failedItems?: any[]) {
    this.name = 'CancelRequestError';
    this.message = message;
    this.retryable = retryable;
    this.failedItems = failedItems;
    this.stack = new Error().stack;
  }
}

export default CancelRequestError;
